import { Link } from 'react-router-dom';
import { Wallet } from 'lucide-react';
import { formatMoney } from '@/lib/money';
import { cn } from '@/lib/utils';

/**
 * What a retainer outreacher sees instead of a rate card. Retainer pay
 * replaces every per-invite amount (log, join, post, follower and niche
 * bonuses), so listing those amounts would only suggest money they won't
 * get.
 */
export const RETAINER_COPY = {
  title: "You're on a weekly retainer",
  body:
    "Per-invite amounts (log, join, post, follower and niche bonuses) don't apply to you. " +
    'Keep logging replies: that is how your work is tracked.',
} as const;

export function RetainerCard({
  retainerAmount,
  className,
}: {
  retainerAmount: string | null;
  className?: string;
}): JSX.Element {
  return (
    <div className={cn('panel flex flex-wrap items-center gap-4 rounded-xl p-5', className)}>
      <span
        aria-hidden
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[0.625rem] border border-brand/25 bg-brand/10 text-brand"
      >
        <Wallet className="h-5 w-5" strokeWidth={1.85} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-[0.9375rem] font-bold">{RETAINER_COPY.title}</p>
        <p className="mt-0.5 max-w-[60ch] text-sm text-muted-foreground">{RETAINER_COPY.body}</p>
      </div>
      <div className="text-right">
        {retainerAmount ? (
          <>
            <p className="font-mono text-2xl font-medium tracking-[-0.04em] tabular-nums">
              ${formatMoney(retainerAmount)}
            </p>
            <p className="text-xs text-muted-foreground">a week</p>
          </>
        ) : (
          <p className="text-sm text-muted-foreground">Amount set by your manager</p>
        )}
        <Link to="/portal/payouts" className="mt-1 inline-block text-xs text-brand hover:underline">
          See payouts
        </Link>
      </div>
    </div>
  );
}
